module.exports = __webpack_public_path__ + "static/media/0327_IMG_LES_ENSEIGNES_LA_CAVE_SCRABBLE.3922aae8.png";